// src/Data/Constants.js
export const Data = {
  name: "Shashank Cheppala",
  phone: "+1 (000) 000-0000", // update with your actual number
  roles: [
    "Data Analytics Student",
    "Machine Learning Enthusiast",
    "Python Developer",
  ],
  email: "your-email@example.com", // update with your actual email
  github: "https://github.com/shashankcheppala",
  linkedIn: "https://linkedin.com/in/shashankcheppala",
  leetcode: "", // optional
  resume: "", // add your resume link if hosted
  description: `I am Shashank Cheppala, a motivated Master's student in Data Analytics with hands-on experience in data science, machine learning, and analytics tools. Passionate about solving real-world problems with data-driven approaches, I combine technical expertise with creativity to deliver impactful insights and solutions.`,

  // --- NEW Medium fields ---
  mediumUser: "shashankcheppala", // your Medium handle (no @)
  mediumUrl: "https://medium.com/@shashankcheppala",
};
